import { ArrayValue, NumberValue, RecordValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../utils/validate-payload.js';
import { resultPartialDefinition, validateResultPayload, } from '../analytics/analytics-utils.js';
const registerRecentResultsPayloadDefinition = {
    results: new ArrayValue({
        required: true,
        each: new RecordValue({ values: resultPartialDefinition }),
    }),
    maxLength: new NumberValue({ required: true, min: 1, default: 10 }),
};
export const registerRecentResults = createAction('recentResults/registerRecentResults', (payload) => validatePayload(payload, registerRecentResultsPayloadDefinition));
export const pushRecentResult = createAction('recentResults/pushRecentResult', (payload) => {
    validateResultPayload(payload);
    return {
        payload,
    };
});
export const clearRecentResults = createAction('recentResults/clearRecentResults');
